import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import { PropTypes } from 'prop-types';

const StyledButton = styled(Button)`
  &:focus {
    box-shadow: ${props => props.theme.forms.input.focusOutline};
  }
`;

class RoomDetailsButton extends Component {
  onClick = () => {
    const { onClick, room } = this.props;

    onClick(room);
  };

  render() {
    return (
      <StyledButton color="link" onClick={this.onClick}>
        See Details
      </StyledButton>
    );
  }
}

RoomDetailsButton.propTypes = {
  onClick: PropTypes.func,
  room: PropTypes.object
};

export default RoomDetailsButton;
